<template>
<!-- 表单组件 -->
 <div class="translateForm">
    <div class="translate_box flex_center" v-show="showInput">
        <textarea @input="inputContent" class="translateInput" cols="30" rows="10" :maxlength="max" :placeholder="'请输入内容,不超过'+max+'字'" v-model="textTotranslate"></textarea>
        <div><p> {{translatedText}}</p></div>
    </div>
    <div class="flex operation_area" >
        <div class="flex">
            <el-select v-model="from" placeholder="请选择" filterable clearable>
                <el-option
                  v-for="item in left"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
            <div @click="handleSwap" class="icon flex_default_center"><i class="el-icon-sort"></i></div>

            <el-select v-model="to" placeholder="请选择" filterable clearable>
                <el-option
                   v-for="item in right"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                </el-option>
            </el-select>
            <el-button :disabled="isUse" size="small" style="margin-left:20px;height:32px;" type="primary" plain @click="formSubmit">翻译</el-button>
        </div>
        <div class="slot">
            <slot></slot>
        </div>
    </div>
   
    <div v-show="showText" v-loading="load" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" class="translated_text"><p> {{translatedText}}</p></div>
    <!-- translatedText    v-loading="load"-->
 </div>
</template>
  
<script>
import { translate } from '@/api/fy'
export default {
 name: 'translateForm',
 props:[
    'showInput',
    'showText',
    'defaultText',
    'max',
    
    'from',
    'to',
 ],
 data () {
  return {
    left:[],
    right:[],
   textTotranslate:"",
   language:"",
   load:false,
   text:'',
    translatedText:'',
    isUse:false,
    leftLang:[
        {
        value:'zh-CHS',
        label:'中文'
        },
      ],
    rightLang:[
   
    {
        value:'en',
        label:'英语'
    },
    {
        value:'ru',
        label:'俄语'
    },
    {
        value:'fa',
        label:'波斯语'
    },
    {
        value:'ko',
        label:'韩语'
    },
    
   ],
  }
 },
 mounted(){
    if(this.from =='zh-CHS'){
        this.left = this.leftLang
        this.right = this.rightLang
    }else{
        this.right = this.leftLang
        this.left = this.rightLang
    }
 },
 methods:{
    inputContent(e){
      
        let iptVal = e.target.value
        this.$emit('getInputVal',iptVal)
    },
    handleSwap(){
        let a = this.to
        let b = this.from
        let c  = this.left
        let d = this.right
        this.to = b
        this.from = a
        this.left =d
        this.right = c
    },
  //点击翻译传给父元素
  formSubmit(){

    if(this.showInput==false){
        this.textTotranslate = this.defaultText
    }
    if(this.to==this.from){
        this.isUse = true
    }
    this.translateTextCus(this.textTotranslate,this.from,this.to)

  },

       async translateTextCus(text,lang1,lang2){
      if(this.showText){
        this.load = true
      }
    let query = {
        data:{
            text:text,
            sourceLanguage:lang1,
            targetLanguage:lang2
        }
    }
      const res = await translate(query)
      if(res.status==0){

        
        this.translatedText=res.data
        this.$emit('getTxt',res.data)

        
        }else{
            this.$DonMessage.warning('第三方接口反馈出错，请点击翻译按钮重试')
        }
        this.load = false
  
    },
    truncate(q) {
    var len = q.length;
    if (len <= 20) return q;
    return q.substring(0, 10) + len + q.substring(len - 10, len);
}
 }
}
</script>
  
<style lang="scss" scoped>
.translateForm{
    .icon{
        cursor: pointer;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #fff;
        transform: rotate(90deg);
        margin: 5px 10px;    
        i{
            color: #333;   
        }
    }
    ::v-deep .el-input__inner{
        width: 100px;
        height: 30px;
        line-height: 30px;
    }
    ::v-deep .el-input__icon{
        line-height: 30px;
    }
    .translate_box{
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        .translateInput{
            border-radius: 5px 0 0 5px;
            width: 50%;
            height: 200px;
            border: 1px solid #eee;
            padding: 5px;
            border-right: none;
            font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        }
        div{
            border-radius:0 5px 5px 0;
            width: 50%;
            height: 200px;
            border: 1px solid #eee;
            padding: 5px;
            background: #E4E7ED;
            color: #333;
            border-left: none;
            overflow-y: scroll;
        }
    }
    .operation_area{
        padding: 0 20px;
        justify-content: space-between;
        margin-top: 20px;
    }
    .translated_text{
        margin-top: 20px;
        border-radius:5px;
        width: 100%;
        min-height: 150px;
        // height: 150px;
        border: 1px solid #eee;
        padding: 10px;
        background: #E4E7ED;
        color: #333;
        border-left: none;
        box-sizing: border-box;
    }

  }
</style>
